import { render, staticRenderFns } from "./bump_trans.vue?vue&type=template&id=67855d6b&scoped=true"
import script from "./bump_trans.vue?vue&type=script&lang=js"
export * from "./bump_trans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67855d6b",
  null
  
)

export default component.exports